<template>
    <div
        class="sbs-counter"
        :class="counterClasses">
        <!-- @slot Слот по-умолчанию -->
        <slot></slot>
        <SbsBaseCounter
            class="sbs-counter__base-counter"
            v-bind="baseCounterData" />
    </div>
</template>

<script>
import themesMixin from '../../mixins/themes.js';
import { isArrayContainsValue } from '../../utils/validators.js';
import {
    AllPositions,
    APP_POSITIONS,
} from '../../utils/positions.js';
import { AllColors } from '../../utils/colors.js';
import SbsBaseCounter from './SbsBaseCounter.vue';

/**
 * Компонент счётчика, позиционируется абсолютно относительно элемента
 */
export default {
    name: 'SbsCounter',
    components: {
        SbsBaseCounter,
    },
    mixins: [themesMixin],
    computed: {
        counterClasses() {
            return [`sbs-counter--${this.position}`];
        },
        baseCounterData() {
            return {
                ...this.$attrs,
                ...this.themeData,
                backgroundColor: this.backgroundColor,
                backgroundTheme: this.backgroundTheme,
                colorTheme: this.colorTheme,
                bordered: this.bordered,
                value: this.value,
            };
        },
    },
    inheritAttrs: false,
    props: {
        /**
         * Цвет фона счётчика
         */
        backgroundColor: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) счётчика
         */
        backgroundTheme: {
            type: String,
            default: AllColors.GRADIENT_PINK,
        },
        /**
         * Определяет наличие бордера у кнопки
         */
        bordered: {
            type: Boolean,
            default: true,
        },
        colorTheme: {
            type: String,
            default: AllColors.WHITE,
        },
        /**
         * Позиционирование счётчика
         */
        position: {
            type: String,
            default: AllPositions.TOP_END,
            validator: isArrayContainsValue(APP_POSITIONS),
        },
        /**
         * Значение счётчика
         */
        value: {
            type: [Number, String],
            default: null,
        },
    },
};
</script>

<style lang="scss">
$counter-offset: 5px;

.sbs-counter {
    position: relative;
    display: inline-flex;

    &__base-counter {
        position: absolute;

        .sbs-counter--top-start & {
            top: -$counter-offset;
            left: -$counter-offset;
        }

        .sbs-counter--top & {
            top: -$counter-offset;
            left: 50%;
            transform: translateX(-50%);
        }

        .sbs-counter--top-end & {
            top: -$counter-offset;
            right: -$counter-offset;
        }

        .sbs-counter--right-start & {
            top: -$counter-offset;
            right: -$counter-offset;
        }

        .sbs-counter--right & {
            top: 50%;
            right: -$counter-offset;
            transform: translateY(-50%);
        }

        .sbs-counter--right-end & {
            right: -$counter-offset;
            bottom: -$counter-offset;
        }

        .sbs-counter--bottom-start & {
            bottom: -$counter-offset;
            left: -$counter-offset;
        }

        .sbs-counter--bottom & {
            bottom: -$counter-offset;
            left: 50%;
            transform: translateX(-50%);
        }

        .sbs-counter--bottom-end & {
            right: -$counter-offset;
            bottom: -$counter-offset;
        }

        .sbs-counter--left-start & {
            top: -$counter-offset;
            left: -$counter-offset;
        }

        .sbs-counter--left & {
            top: 50%;
            left: -$counter-offset;
            transform: translateY(-50%);
        }

        .sbs-counter--left-end & {
            bottom: -$counter-offset;
            left: -$counter-offset;
        }

        .sbs-counter--center & {
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}
</style>
